import React from "react";
import "./RTIInfo.css";




const rtiInfo = {
  title: "📋 माहिती अधिकार अधिनियम 2005 अंतर्गत माहिती",
  items: [
    {
      title: "ग्राम पंचायतची माहिती",
      desc: "ग्राम पंचायत भालेवाडी, दाभा, धावडी(बु), धावडी(खु), लोकसंख्या सुमारे २०११ चे जनगणनेनुसार-१९९८ आणि सध्याची लोकसंख्या-२४३८"
    },
    {
      title: "ग्राम पंचायतची कार्ये",
      desc: "शिक्षण, आरोग्य, स्वच्छता, पाणीपुरवठा, पर्यावरण संवर्धन व ग्रामविकासाची प्रभावी कार्य पार पाडणे."
    },
    {
      title: "निर्णय प्रक्रिया",
      desc: "ग्राम पंचायत अंतर्गत विविध उपक्रम राबविण्यासाठी ग्राम स्तरीय समितीचे गठन करणे व समितीच्या माध्यमातून विकासात्मक कामे करणे. महिलासभा, ग्रामसभा, व वंचित घटकाच्या सभा घेऊन उदिष्ट ठरविणे व प्रत्यक्ष अमलबजावणी करणे."
    },
    {
      title: "नियम व कायदे",
      desc: "महाराष्ट्र ग्राम पंचायत अधिनियम १९५८ नुसार ग्रामपंचायतीचे कामकाज केले जाते."
    },
    {
      title: "कामाचे निकष",
      desc: "१) ग्रा.प. व उपसमितीची सभा घेऊन ध्येय निचहीत करणे. २) मालमत्ता कर, पाणीपट्टि कर चे माध्यमातून ग्रामविकास करण्यासाठी आराखडा तयार करणे व त्यानुसार कार्य पार पाडणे."
    },
    {
      title: "अधिकारी व कर्मचारी",
      desc: "१) प्रशासक- सौ. यशोदा वामन पाटील, २) ग्रा.प. अधिकारी- श्री राजु गोवर्धन शेंदरे, ३) कर्मचारी- श्री ललित सुधाकर चरे, ४) श्री सुरेश रामभाऊजी दुपारे"
    },
    {
      title: "धोरण निर्मिती",
      desc: "ग्रा. प. भालेवाडी विविध विषय सभा, महिला सभा, ग्रामसभा यांचे सभेमध्ये विषयावर चर्चा करून बहुमताने धोरण ठरविले जातात."
    },
    {
      title: "सुविधा",
      desc: "ग्रा. प. भालेवाडी अंतर्गत दिल्या जाणाऱ्या सुविधा १) १००% घरगुती नळ कनेक्शन २) ग्राम उद्योगीत केंद्रामध्ये खाद्यपदार्थ, भांडे, टाकाऊ वस्तूचा वापर करून टिकाऊ साहित्य केंद्र ३) बीपीएल प्रमाणपत्र निशुल्क ४) विवाह प्रमाणपत्र ५) जन्म, मृत्य नोंदणी प्रमाणपत्र"
    },
    {
      title: "उपलब्ध सुविधा",
      desc: "पिण्याचे पाणी, स्वच्छता, रस्ते, वीज आणि सार्वजनिक सुविधा उपलब्ध करून देणे."
    },
    {
      title: "जन माहिती अधिकारी",
      desc: "माहिती अधिकार अधिनियम अंतर्गत जन माहिती अधिकारी १) श्री. राजु गोवर्धन शेंदरे ग्राम पंचायत अधिकारी मो.न. ९७६४५७२९५४ २) अपीलिय अधिकारी श्री. कैलाश गुलाबराव वानखेडे विस्तार अधिकारी (प)"
    },
    {
      title: "प्रथम अपील अधिकारी",
      desc: "संबंधित गट विकास अधिकारी प्रथम अपील अधिकारी म्हणून काम पाहतात."
    },
    {
      title: "ग्रामसभा",
      desc: "गावातील विकासकामे व शासकीय योजनांबाबत चर्चा करण्यासाठी ग्रामसभा आयोजित केली जाते."
    },
    {
      title: "विकास योजना",
      desc: "शासकीय योजनांचा लाभ पात्र लाभार्थ्यांपर्यंत पोहोचविण्याचे काम ग्रामपंचायत करते."
    },
    {
      title: "दस्तऐवज व्यवस्थापन",
      desc: "महत्त्वाची कागदपत्रे, रजिस्टर व नोंदी ग्रामपंचायतीत जतन करून ठेवले जातात."
    },
    {
      title: "परवानगी/सवलती",
      desc: "ग्रा. प. भाळेवाडी अंतर्गत दिलेली परवानगी १) घर बांधकाम परवानगी २) घरगुती विज पुरवठा बाबत NOC ३) शौचालय बांधकाम NOC."
    },
    {
      title: "माहितीचे माध्यम",
      desc: "१) मेरी पंचायत अॅप २) ग्रा. प. वेबसाइट ३) ग्रा. प. सोशल मीडिया/फेसबुक."
    },
    {
      title: "इतर महत्वाची माहिती",
      desc: "ग्राम पंचायत ने सहभाग घेतलेली अभियाने १) संत गाडगेबाबा ग्राम स्वच्छता अभियान २) माझी वसुंधरा अभियान ३) मुख्यमंत्री समृद्ध पंचायत अभियान."
    }
  ]
};

const RTIInfo = () => {
  return (
    <div className="rti-page">
      <section className="rti-hero">
        <h1>{rtiInfo.title}</h1>
        <p>
          ग्रामपंचायत भालेवाडीची माहिती नागरिकांसाठी पारदर्शक पद्धतीने उपलब्ध.
        </p>
      </section>

     

{/* PDF SECTION */}

<section className="pdf-section">
  <h2 className="pdf-title-main">📄 महत्त्वाचे PDF दस्तऐवज</h2>

  <div className="pdf-grid">

    <div className="pdf-card">
      <div className="pdf-icon">📘</div>
      <h3>ग्राम पंचायत सांख्यिकी माहिती</h3>
      <p>ग्राम पंचायतची सांख्यिकी व सामान्य माहिती.</p>

      <div className="pdf-buttons">
        <a
          href={`${process.env.PUBLIC_URL}/images/ग्राम पंचायत सांख्यिकी माहिती.pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          👁 View PDF
        </a>

        <a
          href={`${process.env.PUBLIC_URL}/images/ग्राम पंचायत सांख्यिकी माहिती.pdf`}
          download
        >
          ⬇ Download
        </a>
      </div>
    </div>

    <div className="pdf-card">
      <div className="pdf-icon">📗</div>
      <h3>ग्राम पंचायत विकास समिती भालेवाडी</h3>
      <p>विकास समिती व ग्राम समितीची माहिती.</p>

      <div className="pdf-buttons">
        <a
          href={`${process.env.PUBLIC_URL}/images/ग्राम पंचायत विकास समिती भालेवाडी.pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          👁 View PDF
        </a>

        <a
          href={`${process.env.PUBLIC_URL}/images/ग्राम पंचायत विकास समिती भालेवाडी.pdf`}
          download
        >
          ⬇ Download
        </a>
      </div>
    </div>

     <div className="pdf-card">
    <div className="pdf-icon">📙</div>
    <h3>ग्रामपंचायतीचे अर्थसंकल्प 2025-26</h3>
    <p>ग्राम पंचायत भालेवाडी सन 2025-26 चे अर्थसंकल्प व आर्थिक माहिती.</p>

    <div className="pdf-buttons">
      <a
        href={`${process.env.PUBLIC_URL}/images/भालेवाडी.pdf`}
        target="_blank"
        rel="noopener noreferrer"
      >
        👁 View PDF
      </a>

      <a
        href={`${process.env.PUBLIC_URL}/images/भालेवाडी.pdf`}
        download
      >
        ⬇ Download
      </a>
    </div>
  </div>




    

      

  </div>
</section>

<section className="rti-grid">
        {rtiInfo.items.map((item, index) => (
          <div className="rti-card" key={index}>
            <div className="rti-number">{index + 1}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </section>
    </div>
  );
};
  


export default RTIInfo;


